export const APPLY_THEME = "APPLY_THEME";
export const applyTheme = (color) => {
  return {
    type: APPLY_THEME,
    color: color,
  };
};
